import {
  API_ROUTES,
  NETWORK_ERROR_IDENTIFIER,
  CORS_ERROR_MESSAGE,
  TIMEOUT_ERROR_IDENTIFIER,
  TIMEOUT_ERROR_MESSAGE,
  TIMEOUT_VALUE_MS,
} from "lib/constants";
import client from "services/client";

const timeoutError = {
  message: TIMEOUT_ERROR_MESSAGE,
};

const corsError = {
  message: CORS_ERROR_MESSAGE,
};

const errorPayload = (error) => {
  if (error.code === TIMEOUT_ERROR_IDENTIFIER) {
    return { error: timeoutError };
  } else if (error.message === NETWORK_ERROR_IDENTIFIER) {
    return { error: corsError };
  } else {
    return { error };
  }
};

export const applications = async (accessToken) => {
  client.accessToken = accessToken;

  return await client
    .get(API_ROUTES.dashboard.applications, { timeout: TIMEOUT_VALUE_MS })
    .catch((error) => errorPayload(error));
};

export const applicationSummary = async (accessToken) => {
  client.accessToken = accessToken;

  return await client
    .get(API_ROUTES.dashboard.applicationSummary, { timeout: TIMEOUT_VALUE_MS })
    .catch((error) => errorPayload(error));
};

export const blogData = async (accessToken) => {
  client.accessToken = accessToken;

  return await client
    .get(API_ROUTES.dashboard.blogData, { timeout: TIMEOUT_VALUE_MS })
    .catch((error) => errorPayload(error));
};

export default { applications, applicationSummary, blogData };
